module.exports = __webpack_public_path__ + "media/new-order-alert.6577ad3a.mp3";